import Constant from '@/const';
const axios = require('axios');

const getCategoryMarginStatus = async () => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat('/setting/drug-margin/category'),
    );
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default getCategoryMarginStatus;
